import { useIntl } from "react-intl";
import { useState, useEffect } from "react";
import { getCountryFlag } from "../../../../js/functions";
import { validatePhone } from "../../../../js/validation";

const PhoneCustomField = ({ field, editingFieldId, setEditingFieldId, updateField }) => {
    const intl = useIntl();

    const [localValue, setLocalValue] = useState(field?.value || "");

    const isEditing = editingFieldId === field._id;
    const countryCode = getCountryFlag(isEditing ? localValue : field?.value);

    useEffect(() => {
        if (!isEditing) {
            setLocalValue(field?.value || "");
        }
    }, [field?.value, isEditing]);

    return (
        <div
            className={`flex items-center w-full cursor-text relative rounded-r ${isEditing ? "bg-indigo-50/40" : "hover:bg-indigo-50/50"}`}
            style={{
                padding: "8px 12px",
                paddingLeft: countryCode ? 40 : 12,
                minHeight: 40,
            }}
            onClick={() => {
                if (!isEditing) setEditingFieldId(field._id);
            }}
        >
            {countryCode && (
                <img
                    src={`https://flagcdn.com/w20/${countryCode}.png`}
                    srcSet={`https://flagcdn.com/w40/${countryCode}.png 2x`}
                    alt="flag"
                    className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
                    style={{ width: 20, height: 15, zIndex: 10 }}
                />
            )}

            {isEditing ? (
                <input
                    className="w-full outline-none border-none bg-transparent text-[13px]"
                    style={{ color: 'rgba(15,15,25,0.8)' }}
                    value={localValue}
                    type="tel"
                    placeholder={intl.formatMessage(
                        {
                            id: "ENTER_FIELD",
                            defaultMessage: "Enter {field}",
                        },
                        {
                            field: intl.formatMessage({
                                id: `${field?.name}`.replaceAll(" ", "_").toUpperCase(),
                                defaultMessage: field?.name,
                            }),
                        }
                    )}
                    onChange={(e) => setLocalValue(e.target.value)}
                    autoFocus
                    onBlur={() => {
                        if (validatePhone(localValue)) {
                            updateField(field._id, localValue.trim());
                        } else {
                            updateField(field._id, "");
                            setLocalValue("");
                        }
                        setEditingFieldId(false);
                    }}
                />
            ) : field?.value ? (
                <a
                    href={`tel:${field?.value}`}
                    className="cursor-pointer text-[13px] text-[#3B82F6]"
                    onClick={(e) => e.stopPropagation()}
                >
                    {field?.value}
                </a>
            ) : (
                <span className="text-[13px]" style={{ color: 'rgba(15,15,25,0.28)' }}>Empty</span>
            )}
        </div>
    );
};

export default PhoneCustomField;